var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        ((_obj = {}),
        (_obj[_vm.$style.maskCover] = true),
        (_obj[_vm.$style.left] = _vm.left),
        (_obj[_vm.$style.right] = _vm.right),
        _obj),
      attrs: { "data-ui-section": "arrow" },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c(
        "div",
        {
          class:
            ((_obj$1 = {}),
            (_obj$1[_vm.$style.cover] = true),
            (_obj$1[_vm.externalStyle.background] = true),
            (_obj$1[_vm.$style.show] = _vm.show),
            _obj$1),
          style: _vm.transformOverride
        },
        [
          _c("i", {
            staticClass: "material-icons",
            class: _vm.$style.arrow,
            attrs: { "data-icon": _vm.iconText }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }